/**
Project: Voice Panel (c)
Title: Signin Silent End 
Description: Component for success or failure callback after the authentication check of teams sign in
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { AuthenticationContext } from "react-adal";
import { AppURLProps } from "../settings/app-urls";

class SigninSilentEnd extends Component {
  componentDidMount() {
    this.interactive();
  }
  interactive = () => {
    const azureActiveDirectoryAppId =
      process.env.REACT_APP_AZURE_ACTIVE_DIRECTORY_APP_ID;
    microsoftTeams.initialize();

    let config = {
      clientId: azureActiveDirectoryAppId,
      redirectUri: window.location.origin + AppURLProps.signinSilentEnd,
      cacheLocation: "localStorage",
      navigateToLoginRequestUrl: false,
    };
    let authContext = new AuthenticationContext(config);
    if (authContext.isCallback(window.location.hash)) {
      authContext.handleWindowCallback(window.location.hash);
      if (window.parent === window) {
        if (authContext.getCachedUser()) {
          microsoftTeams.authentication.notifySuccess();
        } else {
          microsoftTeams.authentication.notifyFailure(
            authContext.getLoginError()
          );
        }
      }
    } else {
      microsoftTeams.authentication.notifyFailure(
        authContext.getLoginError()
      );
    }
  };
  render() {
    return <></>;
  }
}

export default SigninSilentEnd;
